import { ACTIONS, KEYS } from "../../_config";
import { ActionExtended } from "../../_config/interfaces/interfaces";

export interface UserReducer {
  user: any;
  accessToken: string | null;
  refreshToken: string | null;
  refreshTokenExpiryTime: string | null;
  isAuthenticated: boolean;
  permissions: any;
  menus: any[];
  menuPermissions: any;
}

const initialState: UserReducer = {
  user: null,
  accessToken: null,
  refreshToken: null,
  refreshTokenExpiryTime: null,
  isAuthenticated: false,
  permissions: null,
  menus: [],
  menuPermissions: {},
};

const userReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.USER.LOGIN:
      return {
        ...state,
        user: action.payload.user,
        accessToken: action.payload.accessToken || localStorage.getItem(KEYS.AUTH_ACCESS),
        refreshToken: action.payload.refreshToken || localStorage.getItem(KEYS.AUTH_REFRESH),
        refreshTokenExpiryTime: action.payload.refreshTokenExpiryTime || localStorage.getItem(KEYS.REFRESH_TOKEN_EXPIRY),
        isAuthenticated: true,
        permissions: action.payload.permissions,
      };

    case ACTIONS.USER.UPDATE_TOKENS:
      return {
        ...state,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        refreshTokenExpiryTime: action.payload.refreshTokenExpiryTime,
      };

    case ACTIONS.USER.USER:
      return {
        ...state,
        user: action.payload,
      };

    case ACTIONS.USER.MENUS:
      return {
        ...state,
        menus: action.payload,
      };

    case ACTIONS.USER.MENU_PERMISSIONS:
      return {
        ...state,
        menuPermissions: action.payload,
      };

    case ACTIONS.USER.LOGOUT:
      return {
        ...state,
        user: null,
        accessToken: null,
        refreshToken: null,
        refreshTokenExpiryTime: null,
        isAuthenticated: false,
        permissions: null,
        menus: [],
        menuPermissions: {},
      };
    default:
      return state;
  }
};

export default userReducer;
